import React from "react";
import { newLineToBr } from "../../utilities";

const InvitationBody = ({ message, displayLabel }: { message?: string, displayLabel?: boolean }) => {
  if (message) {
    return (
      <div className="padding-larger panel-bg-color" style={{ lineHeight: "1.3em" }}>
        {displayLabel && <div className="margin-bottom-small">
          <strong>{RESX.Advancing.PersonalMessage}:</strong>
        </div>}

        {newLineToBr(message)}
      </div >
    );
  }

  return <div className="padding-larger panel-bg-color">
    {RESX.Advancing.NoPersonalMessage}
  </div>;
};

export default InvitationBody;